// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutOrderDetailsStyles } from "@bg/App/Widgets/OnePageCheckout/OnePageCheckoutOrderDetails";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { css } from "styled-components";

onePageCheckoutOrderDetailsStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px 60px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

onePageCheckoutOrderDetailsStyles.titleText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
        grid-column: 1 /3;
        ${xScreen("lte", "md")} {
            grid-column: initial;
        }
    `,
};

onePageCheckoutOrderDetailsStyles.poNumberText = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

onePageCheckoutOrderDetailsStyles.pickUpDateWrapper = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutOrderDetailsStyles.deliveryDateWrapper = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutOrderDetailsStyles.notesWrapper = {
    css: css`
        grid-column: 2/3;
        ${xScreen("lte", "md")} {
            grid-column: initial;
        }
    `,
};

onePageCheckoutOrderDetailsStyles.deliveryDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

onePageCheckoutOrderDetailsStyles.pickUpDatePicker = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

onePageCheckoutOrderDetailsStyles.notesTextArea = {
    cssOverrides: {
        inputSelect: css`
            resize: none;
            height: 80px;
        `,
    },
};
